module.exports = __webpack_public_path__ + "static/media/payment-fill.250824d8.svg";